module.exports = __webpack_public_path__ + "media/application/images/company/founders-bw/Colin-Joudrie-04be72c2fc8af1589d8e5d3210152d03.jpg";